import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaChevronLeft, FaChevronRight, FaVideo } from 'react-icons/fa';

const Calendar = () => {
    const [currentDate] = useState(new Date());

    const sessions = [
        { date: 15, time: '14:00 - 15:00', subject: 'Mathematics', tutor: 'Mr. Thompson', type: 'live' },
        { date: 17, time: '15:00 - 16:00', subject: 'Physics', tutor: 'Dr. Wilson', type: 'live' },
        { date: 19, time: '13:00 - 14:00', subject: 'Chemistry', tutor: 'Ms. Ahmed', type: 'live' },
        { date: 20, time: '16:00 - 17:00', subject: 'Mathematics', tutor: 'Mr. Thompson', type: 'live' }
    ];

    const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    return (
        <div>
            <h1 style={{ fontSize: '1.8rem', fontWeight: 'bold', color: 'var(--color-secondary)', marginBottom: '0.5rem' }}>Calendar</h1>
            <p style={{ color: '#666', marginBottom: '2rem' }}>View your upcoming sessions</p>

            <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '1.5rem' }}>
                {/* Calendar View */}
                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    style={{ background: 'white', padding: '1.5rem', borderRadius: '12px', border: '1px solid #eee' }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
                        <h3 style={{ fontWeight: '600', fontSize: '1.2rem' }}>
                            {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
                        </h3>
                        <div style={{ display: 'flex', gap: '0.5rem' }}>
                            <button style={{ padding: '0.5rem', border: '1px solid #ddd', borderRadius: '6px', background: 'white', cursor: 'pointer' }}>
                                <FaChevronLeft />
                            </button>
                            <button style={{ padding: '0.5rem', border: '1px solid #ddd', borderRadius: '6px', background: 'white', cursor: 'pointer' }}>
                                <FaChevronRight />
                            </button>
                        </div>
                    </div>

                    {/* Calendar Grid */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '0.5rem' }}>
                        {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
                            <div key={day} style={{ textAlign: 'center', fontWeight: '600', color: '#666', padding: '0.5rem', fontSize: '0.9rem' }}>
                                {day}
                            </div>
                        ))}
                        {Array.from({ length: 35 }, (_, i) => {
                            const dayNum = i - 2; // Adjust based on month start
                            const hasSession = sessions.some(s => s.date === dayNum);
                            const isToday = dayNum === currentDate.getDate();

                            return (
                                <div
                                    key={i}
                                    style={{
                                        padding: '0.75rem',
                                        textAlign: 'center',
                                        borderRadius: '8px',
                                        background: isToday ? 'var(--color-primary)' : hasSession ? 'var(--color-teal-light)' : 'transparent',
                                        color: isToday ? 'white' : hasSession ? 'var(--color-primary)' : dayNum > 0 && dayNum <= 31 ? '#333' : '#ddd',
                                        fontWeight: hasSession || isToday ? '600' : 'normal',
                                        cursor: dayNum > 0 && dayNum <= 31 ? 'pointer' : 'default'
                                    }}
                                >
                                    {dayNum > 0 && dayNum <= 31 ? dayNum : ''}
                                </div>
                            );
                        })}
                    </div>
                </motion.div>

                {/* Upcoming Sessions */}
                <motion.div
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    style={{ background: 'white', padding: '1.5rem', borderRadius: '12px', border: '1px solid #eee' }}
                >
                    <h3 style={{ fontWeight: '600', marginBottom: '1rem' }}>Upcoming Sessions</h3>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        {sessions.map((session, index) => (
                            <div key={index} style={{
                                padding: '1rem',
                                background: '#f8f9fa',
                                borderRadius: '8px',
                                borderLeft: '4px solid var(--color-primary)'
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                                    <FaVideo size={14} color="var(--color-primary)" />
                                    <div style={{ fontWeight: '600', fontSize: '0.9rem' }}>{session.subject}</div>
                                </div>
                                <div style={{ fontSize: '0.85rem', color: '#666', marginBottom: '0.25rem' }}>
                                    Dec {session.date}, {session.time}
                                </div>
                                <div style={{ fontSize: '0.85rem', color: '#666' }}>
                                    with {session.tutor}
                                </div>
                            </div>
                        ))}
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default Calendar;
